import { Hourglass } from 'lucide-react';
import { cn } from '@/lib/utils';
import { countdownAnnouncement, formatCountdown } from './meetingCountdown';
import { useMeetingCountdown } from './useMeetingCountdown';

export const COUNTDOWN_LABEL = 'A reunião termina em';

/**
 * A contagem regressiva dos 5 minutos finais da reunião: "A reunião termina em 04:32". Aparece para o atendente e para o
 * convidado quando falta 5 minutos ou menos e fica até a chamada acabar; no último minuto fica vermelha. Sem limite de
 * duração (ou antes de a reunião começar) não aparece.
 *
 * O texto é o do cronômetro (`role="timer"`, que não é lido a cada segundo); um aviso à parte (`role="status"`) anuncia a
 * mudança de minuto e o último minuto para quem usa leitor de tela.
 *
 * @param {{ compact?: boolean }} props `compact`: janela pequena (flutuante ou do canto), com texto menor
 */
export function MeetingCountdown({ compact = false }) {
    const state = useMeetingCountdown();
    const announcement = countdownAnnouncement(state);
    if (!state.visible) return null;

    return (
        <>
            <span
                role="timer"
                aria-label={`${COUNTDOWN_LABEL} ${formatCountdown(state.remainingSeconds)}`}
                data-meeting-countdown=""
                data-urgent={state.urgent ? 'true' : 'false'}
                className={cn(
                    'pointer-events-auto inline-flex shrink-0 items-center gap-1.5 rounded-full px-2.5 py-1 font-medium tabular-nums shadow-lg ring-1',
                    compact ? 'text-xs' : 'text-sm',
                    state.urgent ? 'bg-red-600 text-white ring-red-300/50' : 'bg-amber-400 text-black ring-amber-200/60',
                )}
            >
                <Hourglass className={cn('h-3.5 w-3.5 shrink-0', state.urgent && 'animate-pulse motion-reduce:animate-none')} aria-hidden="true" />
                <span aria-hidden="true">{COUNTDOWN_LABEL}</span>
                {/* O afastamento é só visual (gap): o espaço no texto mantém "em 04:32" legível ao selecionar e copiar */}
                {' '}
                <span aria-hidden="true" className="font-mono">{formatCountdown(state.remainingSeconds)}</span>
            </span>
            <span role="status" className="sr-only">{announcement}</span>
        </>
    );
}
